/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Toolbar_Fileextensions1Inputs */

const id_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekstensi File`)
};

const ms_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sambungan Fail`)
};

const da_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filudvidelser`)
};

const de_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateierweiterungen`)
};

const en_us2_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Extensions`)
};

const es_es2_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensiones de archivo`)
};

const es_mx2_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensiones de archivo`)
};

const fil_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Extension ng File`)
};

const fr_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensions de fichier`)
};

const it_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estensioni file`)
};

const hu_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fájlkiterjesztések`)
};

const nl_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestandsextensies`)
};

const no_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filutvidelser`)
};

const pl_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozszerzenia plików`)
};

const pt_br2_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Extensions`)
};

const pt_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensões de ficheiro`)
};

const ro_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensii fișiere`)
};

const fi_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiedostopäätteet`)
};

const sv_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtillägg`)
};

const vi_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phần mở rộng tệp`)
};

const tr_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosya Uzantıları`)
};

const cs_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přípony souborů`)
};

const bg_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файлови разширения`)
};

const ru_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расширения файлов`)
};

const uk_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розширення файлів`)
};

const ar_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`امتدادات الملفات`)
};

const hi_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल एक्सटेंशन`)
};

const th_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นามสกุลไฟล์`)
};

const ja_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイル拡張子`)
};

const zh_cn2_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Extensions`)
};

const zh_hant1_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Extensions`)
};

const ko_table_toolbar_fileextensions1 = /** @type {(inputs: Table_Toolbar_Fileextensions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Extensions`)
};

/**
* | output |
* | --- |
* | "File Extensions" |
*
* @param {Table_Toolbar_Fileextensions1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_toolbar_fileextensions1 = /** @type {((inputs?: Table_Toolbar_Fileextensions1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Toolbar_Fileextensions1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_toolbar_fileextensions1(inputs)
	if (locale === "ms") return ms_table_toolbar_fileextensions1(inputs)
	if (locale === "da") return da_table_toolbar_fileextensions1(inputs)
	if (locale === "de") return de_table_toolbar_fileextensions1(inputs)
	if (locale === "en-US") return en_us2_table_toolbar_fileextensions1(inputs)
	if (locale === "es-ES") return es_es2_table_toolbar_fileextensions1(inputs)
	if (locale === "es-MX") return es_mx2_table_toolbar_fileextensions1(inputs)
	if (locale === "fil") return fil_table_toolbar_fileextensions1(inputs)
	if (locale === "fr") return fr_table_toolbar_fileextensions1(inputs)
	if (locale === "it") return it_table_toolbar_fileextensions1(inputs)
	if (locale === "hu") return hu_table_toolbar_fileextensions1(inputs)
	if (locale === "nl") return nl_table_toolbar_fileextensions1(inputs)
	if (locale === "no") return no_table_toolbar_fileextensions1(inputs)
	if (locale === "pl") return pl_table_toolbar_fileextensions1(inputs)
	if (locale === "pt-BR") return pt_br2_table_toolbar_fileextensions1(inputs)
	if (locale === "pt") return pt_table_toolbar_fileextensions1(inputs)
	if (locale === "ro") return ro_table_toolbar_fileextensions1(inputs)
	if (locale === "fi") return fi_table_toolbar_fileextensions1(inputs)
	if (locale === "sv") return sv_table_toolbar_fileextensions1(inputs)
	if (locale === "vi") return vi_table_toolbar_fileextensions1(inputs)
	if (locale === "tr") return tr_table_toolbar_fileextensions1(inputs)
	if (locale === "cs") return cs_table_toolbar_fileextensions1(inputs)
	if (locale === "bg") return bg_table_toolbar_fileextensions1(inputs)
	if (locale === "ru") return ru_table_toolbar_fileextensions1(inputs)
	if (locale === "uk") return uk_table_toolbar_fileextensions1(inputs)
	if (locale === "ar") return ar_table_toolbar_fileextensions1(inputs)
	if (locale === "hi") return hi_table_toolbar_fileextensions1(inputs)
	if (locale === "th") return th_table_toolbar_fileextensions1(inputs)
	if (locale === "ja") return ja_table_toolbar_fileextensions1(inputs)
	if (locale === "zh-CN") return zh_cn2_table_toolbar_fileextensions1(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_toolbar_fileextensions1(inputs)
	return ko_table_toolbar_fileextensions1(inputs)
});
export { table_toolbar_fileextensions1 as "table.toolbar.fileExtensions" }